
export class LoggedInUser {
  userId: string;
  companyId: number;
  userName: string;
  fullName: string;
  email: string;
  token: string;
  tokenExpireDate: Date;
  role: Role;
  roleId: number;
  validity: Date;
  isSpaOrSa: boolean;
  isCompanyMoreThenOne: boolean;
  isSecurityCodeEnabled: boolean;
  isSecurityCodeSet: boolean;
}

export enum Role {
  SystemPowerAdmin = 1,
  SystemUser = 2,
  ClientAdmin = 3,
  ClientUser = 4,
  SystemAdmin = 5,
  Resources = 6,
  SystemPowerAdminDescription = "System Power Admin",
  SystemUserDescription = "System User",
  ClientAdminDescription = "Client Admin",
  ClientUserDescription = "Client User",
  SystemAdminDescription = "System Admin",
  ResourcesDescription = "Resources"
}

export enum Permission {

  ManageMyCompanyDetail = 1,
  ManageMyCompanyDetailsDescription = "Manage My Company Details (Client Profile)",

  ManageClientUsers = 2,
  ManageClientUsersDescription = "Manage Client Users",

  ManageClientsDeviceInventory = 3,
  ManageClientsDeviceInventoryDescription = "Manage Client's Device Inventory",

  ImportVulenaribiltyReports = 4,
  ImportVulenaribiltyReportsDescription = "Import Vulenaribilty Reports",

  CreateAssessment = 5,
  CreateAssessmentDescription = "Create Assessment"

}

